import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ThemePalette} from '@angular/material/core';
import {ProgressSpinnerMode} from '@angular/material/progress-spinner';
import {Session} from '../../../interfaces/session-data';
import {HttpErrorResponse} from '@angular/common/http';
import {OzowInitiateResponse} from 'src/app/interfaces/ozow/ozow';
import {OzowService} from 'src/app/services/ozow/ozow.service';

@Component({
  selector: 'app-ozow',
  templateUrl: './ozow.component.html',
  styleUrls: ['./ozow.component.scss']
})
export class OzowComponent implements OnInit {

  paymentMethod: string;
  paymentMethodImg = '';
  redirectUrl;
  controllerUrl;
  loading = true;
  ozowInitiateResponse: OzowInitiateResponse;

  // Loader
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  value = 50;
  diameter = 75;

  //Countdown
  config = { leftTime: 5, format: 's' };
  hidePgLogo = false;
  sessionData: Session;

  constructor(
    private ozowService: OzowService,
    private router: Router
  ) {
    sessionStorage.setItem('selected-payment', 'eft_ozow');
    this.paymentMethod = 'eft_ozow';
    this.paymentMethodImg = `../../assets/icons/Payment_Cards/svg/image_${this.paymentMethod}.png`;

  }

  ngOnInit(): void {
    this.sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    this.hidePgLogo = this.sessionData?.sessionDisplayInformation?.hidePgLogo === 'true';
    this.ozowService.initializePayment(sessionStorage.getItem('sessionToken')).subscribe((data: OzowInitiateResponse) => {
      this.ozowInitiateResponse = data;
      setTimeout(() => {
        const ozowForm = (document.getElementById('ozow-form') as HTMLFormElement);
        ozowForm.submit();
      }, 750);
    }, (err: HttpErrorResponse) => {
      this.navigateToStatus();
    });
  }

  navigateToStatus() {
    this.loading = false;
    this.router.navigate(
      [`transaction-status`]);
  }

}
